export default class ListaNotas {
    constructor(elemento) {
        this.elemento = elemento;
        this.configurar();
    }

    configurar() {
        this.defList = document.createElement("dl");
        this.defList.className = this.elemento.className;
        this.defList.setAttribute("data-section", this.elemento.getAttribute("data-section"));
        const listItems = this.elemento.children;
        let defTerm, defTermLink, defTermLabel, defDescription, listItemId;
        for(const listItem of listItems) {
          listItemId = listItem.id.split("-");
          defTerm = document.createElement("dt");
          defTermLink = document.createElement("a");
          defTermLabel = document.createElement("span");
          defTermLabel.className = "oculto-visual";
          defTermLabel.textContent = "Nota de " + listItemId[1] + " " + listItemId[2];
          defTermLink.id = listItem.id;
          defTermLink.setAttribute("href", `#ref-${listItemId[1]}-${listItemId[2]}`);
          defTermLink.appendChild(defTermLabel);
          defTerm.appendChild(defTermLink);
          defDescription = document.createElement("dd");
          defDescription.innerHTML = listItem.innerHTML;
          
          this.defList.appendChild(defTerm);
          this.defList.appendChild(defDescription);
        }
        
        this.elemento.replaceWith(this.defList);
    }
}
